import { ComparasionInsurersFormValues } from '@/core/domain/workorder/ManagementCharts/ManagementChart.types';
import { Form, Modal, ModalProps } from 'antd';
import React from 'react';
import SalesInsuranceComparisonForm from './SalesInsuranceComparisonForm';

type Props = Omit<ModalProps, 'onOk'> & {
  handleOk: (values: ComparasionInsurersFormValues) => void;
};

const SalesInsuranceComparisonModal: React.FC<Props> = ({
  open,
  onCancel,
  handleOk,
}) => {
  const [form] = Form.useForm<ComparasionInsurersFormValues>();

  return (
    <Modal
      title="Comparativa por seguradoras"
      open={open}
      onCancel={onCancel}
      width={600}
      okText="Atualizar Gráfico"
      onOk={async () => {
        try {
          const values = await form.validateFields();
          handleOk({
            ...values,
            startDate: values?.startDate.startOf('day'),
            endDate: values?.endDate.endOf('day'),
          });
        } catch {}
      }}
    >
      <SalesInsuranceComparisonForm form={form} />
    </Modal>
  );
};

export default SalesInsuranceComparisonModal;
